<script lang="ts" setup>
import type { DescriptorVM } from '@/types/view';
import { computed, inject,  toRef } from 'vue'
import { DomainTransKey } from '@/i18n/domainTrans'
import { ModuleLocaleKey } from '@/i18n/moduleLocaleContext'
import { ColorScaleKey } from '@/ui/colorScaleContext'
const colorCtx = inject(ColorScaleKey)!
const dt = inject(DomainTransKey)!
const moduleLocale = inject(ModuleLocaleKey, { baseLocale: computed(() => 'no') })

const props = defineProps<{
  descriptor: DescriptorVM
  isExpanded?: boolean
  hideTotals?: boolean
  highlight?: boolean
  gradientOverride?: boolean
}>()

const emits = defineEmits(['on-select'])
const isExpanded = toRef(props, 'isExpanded')
const descriptor = toRef(props, 'descriptor')

const $color = computed(() => {
  if(descriptor.value.evaluatedStatementCount == 0) {
    return colorCtx.scale.value.at(null)
  }
  const v = props.descriptor.averageEvaluation
  return Number.isFinite(v) ? colorCtx.scale.value.at(v) : colorCtx.scale.value.at(null)
})


</script>

<template>
  <div class="descriptor-wrapper" @click="emits('on-select', descriptor)">
    <div v-if="descriptor.gradientStyle && gradientOverride == true" class="gradient-wrapper">
      <div class="gradient-header">
        {{ dt.t(descriptor.title, descriptor.title_i18n, moduleLocale.baseLocale.value) }}
      </div>
      <div class="gradient" :style="{ backgroundImage: descriptor.gradientStyle }"></div>
    </div>
    <div v-else>
      <button :style="{ 'border-color': $color }" :class="{ header: isExpanded, highlight: props.highlight }">
        <span class="descriptor-item-title">
          {{ dt.t(descriptor.title, descriptor.title_i18n, moduleLocale.baseLocale.value) }}
          <span v-if="!hideTotals">
            ({{ descriptor.evaluatedStatementCount }}/{{ descriptor.statementCount }})
          </span>
        </span>
      </button>
    </div>
  </div>
</template>
<style scoped>
.descriptor-item-title,
.arrow-ico {
  padding-top: 4px;
}

.descriptor-item-title {
  flex-grow: 1;
}

button {
  border: solid;
  border-width: 0 0 0 18px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #f2f2f2;
}

button.header {
  border-width: 0 0 18px 0;
  min-height: 48px;
}

button.highlight {
  color: black;
}

.gradient-wrapper {
  padding-bottom: 8px;
}

.gradient {
  width: 100;
  border-radius: 0px 0px 8px 8px;
  padding-bottom: 18px;
}

.gradient-header {
  width: 100;
  border-radius: 8px 8px 0 0;
  height: 16;
  padding: 8px 0;
  font-size: 14px;
  background-color: white;
  color: black;
  text-align: center;
}
</style>
